var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disable ? 'tw-text-gray-300 block-header':'block-header'},[_c('span',{staticClass:"small-span"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"q-table__title"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }